webpackJsonp([35783957827783],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _monogram = __webpack_require__(137);
	
	var _monogram2 = _interopRequireDefault(_monogram);
	
	var _fern = __webpack_require__(135);
	
	var _fern2 = _interopRequireDefault(_fern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrontPageHero = function (_React$Component) {
	  _inherits(FrontPageHero, _React$Component);
	
	  function FrontPageHero() {
	    _classCallCheck(this, FrontPageHero);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  FrontPageHero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'front-page-hero landing-hero' },
	      _react2.default.createElement(
	        'div',
	        { className: 'front-page-hero front-page-hero--monogram' },
	        _react2.default.createElement('img', {
	          src: _monogram2.default,
	          alt: 'The monogram for the wedding, an S intertwined with an A'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'overlay' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fern fern-left' },
	          _react2.default.createElement('img', { src: _fern2.default, alt: 'An illustration of ferns' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fern fern-right' },
	          _react2.default.createElement('img', { src: _fern2.default, alt: 'An illustration of ferns' })
	        )
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: 'front-page-hero--heading' },
	        this.props.heading
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'front-page-hero--subheading' },
	        this.props.subheading
	      )
	    );
	  };
	
	  return FrontPageHero;
	}(_react2.default.Component);
	
	exports.default = FrontPageHero;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FacebookGroupIcon = __webpack_require__(79);
	
	var _FacebookGroupIcon2 = _interopRequireDefault(_FacebookGroupIcon);
	
	var _RSVPIcon = __webpack_require__(80);
	
	var _RSVPIcon2 = _interopRequireDefault(_RSVPIcon);
	
	var _RegistryIcon = __webpack_require__(81);
	
	var _RegistryIcon2 = _interopRequireDefault(_RegistryIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const background_plaid_tartan = withPrefix(
	//   'static/backgrounds/black_watch_tartan_pattern.svg'
	// );
	// const threeColStyle = {
	//   backgroundImage: `url('${background_plaid_tartan}')`,
	// };
	// style={threeColStyle}
	var ThreeCol = function ThreeCol(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'three-col' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col col-facebook' },
	      _react2.default.createElement(
	        'a',
	        { href: props.facebook_url },
	        _react2.default.createElement(_FacebookGroupIcon2.default, { className: 'icon' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'link-text' },
	          'Join the Facebook group'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col col-rsvp' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/rsvp' },
	        _react2.default.createElement(_RSVPIcon2.default, { className: 'icon' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'link-text' },
	          'RSVP to the Wedding'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col col-registry' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/registry' },
	        _react2.default.createElement(_RegistryIcon2.default, { className: 'icon' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'link-text' },
	          'Check out the registry'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ThreeCol;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fern.f1487089.svg";

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(22);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(21);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FrontPageHero = __webpack_require__(78);
	
	var _FrontPageHero2 = _interopRequireDefault(_FrontPageHero);
	
	var _ThreeCol = __webpack_require__(237);
	
	var _ThreeCol2 = _interopRequireDefault(_ThreeCol);
	
	var _Polaroid = __webpack_require__(58);
	
	var _Polaroid2 = _interopRequireDefault(_Polaroid);
	
	var _andy_sarah_engagement_portrait = __webpack_require__(498);
	
	var _andy_sarah_engagement_portrait2 = _interopRequireDefault(_andy_sarah_engagement_portrait);
	
	var _andy_sarah_engagement_portrait2x = __webpack_require__(499);
	
	var _andy_sarah_engagement_portrait2x2 = _interopRequireDefault(_andy_sarah_engagement_portrait2x);
	
	var _auditorium2x = __webpack_require__(138);
	
	var _auditorium2x2 = _interopRequireDefault(_auditorium2x);
	
	var _holidayInn = __webpack_require__(501);
	
	var _holidayInn2 = _interopRequireDefault(_holidayInn);
	
	var _holidayInn2x = __webpack_require__(502);
	
	var _holidayInn2x2 = _interopRequireDefault(_holidayInn2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var polaroid_announcement = {
	  image: {
	    src: _andy_sarah_engagement_portrait2x2.default,
	    src2x: _andy_sarah_engagement_portrait2x2.default,
	    alt: ''
	  },
	  icon: 'fireworks',
	  heading: 'Sarah and Andy are getting married!',
	  body: 'After nine years, including two band camps, senior prom, eleven snowboard trips, college, a long distance relationship, sixteen jobs, hundreds of movies, thousands of photos, and everyone we’ve ever met asking us when we were going to get hitched, its finally happening.',
	  alignment: 'left'
	};
	var polaroid_location = {
	  image: {
	    src: _auditorium2x2.default,
	    src2x: _auditorium2x2.default,
	    alt: ''
	  },
	  icon: 'location',
	  heading: 'The Wedding',
	  body: 'A little of Methuen and a little of Lowell. We’re getting married at the Methuen Memorial Music Hall and we’re celebrating at the Lowell Memorial Auditorium.',
	  alignment: 'right',
	  button: {
	    label: 'More Info',
	    href: '/wedding-details'
	  },
	  texture: 'monogram'
	};
	var polaroid_accomodations = {
	  theme: 'dark',
	  image: {
	    src: _holidayInn2.default,
	    src2x: _holidayInn2x2.default,
	    alt: ''
	  },
	  icon: 'hotel',
	  heading: 'Accomodations',
	  body: 'We have blocked some rooms for you at the Holiday Inn in Tewksbury. If you want to stay call (978) 640-9000 and mention you are booking for the Croughwell/Lincoln Wedding. ',
	  links: [{ label: 'Book at the Inn and Conference Center', href: '/' }, { label: 'Book at the Fairfield', href: '/' }],
	  alignment: 'left',
	  texture: 'fern'
	};
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'front-page' },
	    _react2.default.createElement(_Header2.default, { front_page: true }),
	    _react2.default.createElement(_FrontPageHero2.default, {
	      heading: 'We\'re saying \u201CI Do\u201D',
	      subheading: 'Methuen, Massachusetts November 24, 2018'
	    }),
	    _react2.default.createElement(_ThreeCol2.default, { facebook_url: 'https://www.facebook.com/groups/lincolncroughwellwedding/' }),
	    _react2.default.createElement(_Polaroid2.default, polaroid_announcement),
	    _react2.default.createElement(_Polaroid2.default, polaroid_location),
	    _react2.default.createElement(_Polaroid2.default, polaroid_accomodations),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/andy_sarah_engagement_portrait.f41e9e72.jpg";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/andy_sarah_engagement_portrait@2x.84f4b64d.jpg";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/auditorium@2x.d572a033.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/holiday-inn.8efab6fa.png";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/holiday-inn@2x.23266246.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4538a61de954909a87d8.js